<template lang="pug">
v-card.box2x(v-if="invoice" @click="onPaymentClick" min-height="250px")
    v-card-title {{ $t('dashboardPage.invoice') }}
    v-card-subtitle {{ invoiceLabel }}
    v-col.text-h3.text--black
        v-row.pa-4
            v-spacer
            div.pb-0.pr-1.font-weight-bold {{ invoice.formattedPriceTotal }}
            v-icon.font-weight-bold.ml-2(x-large color="black") fal fa-euro-sign
        v-row
            v-btn(text) {{ $t('dashboardPage.moreInformation') }}
    v-col(v-if="showInvoiceDetailDialog")
        InvoiceDetailDialog(v-if="showInvoiceDetailDialog" :show="showInvoiceDetailDialog" :invoice="invoice" @close="closeInvoiceDetailDialog")
</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {FETCH_MY_LATEST_INVOICES} from '@/store/action-types'
import Moment from 'moment'
import {Invoice} from '@/model/Invoice'
import InvoiceDetailDialog from '@/components/InvoiceDetailDialog.vue'

@Component({
  components: {
    InvoiceDetailDialog
  }
})
export default class LatestInvoice extends Vue {
  @Action(FETCH_MY_LATEST_INVOICES) fetchLatestInvoice!: ({ (): Promise<Invoice> })

  private invoice: Invoice | null = null
  private showInvoiceDetailDialog: boolean = false

  get invoiceLabel(): string {
    if (this.invoice) {
      return Moment(this.invoice.periodStart)
        .locale('sk-sk')
        .format('MMMM YYYY')
    }

    return ''
  }

  closeInvoiceDetailDialog() {
    this.showInvoiceDetailDialog = false
  }

  onPaymentClick(): void {
    this.showInvoiceDetailDialog = true
  }

  async fetchData(): Promise<void> {
    this.invoice = await this.fetchLatestInvoice()
  }

  mounted(): void {
    this.fetchData()
  }
}
</script>

<style lang="stylus" scoped>

</style>
